(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-lovalo-review-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-lovalo-carousel-viewport]');
    const cards = Array.from(carousel.querySelectorAll('[data-lovalo-carousel-card]'));
    const previous = carousel.querySelector('[data-lovalo-carousel-previous]');
    const next = carousel.querySelector('[data-lovalo-carousel-next]');
    const counter = carousel.querySelector('[data-lovalo-carousel-current]');

    if (!viewport || cards.length === 0 || !previous || !next) return;

    let activeIndex = 0;
    let autoplayTimer = null;
    let restartTimer = null;
    let scrollFrame = null;

    const setCounter = () => {
      if (counter) counter.textContent = String(activeIndex + 1);
    };

    const closestVisibleCard = () => {
      const viewportBox = viewport.getBoundingClientRect();
      const viewportStart = viewportBox.right;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      cards.forEach((card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().right - viewportStart);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      activeIndex = closestIndex;
      setCounter();
    };

    const showCard = (index, smooth = true) => {
      activeIndex = (index + cards.length) % cards.length;
      const viewportBox = viewport.getBoundingClientRect();
      const cardBox = cards[activeIndex].getBoundingClientRect();

      viewport.scrollBy({
        left: cardBox.right - viewportBox.right,
        behavior: smooth && !reducedMotion.matches ? 'smooth' : 'auto',
      });
      setCounter();
    };

    const stopAutoplay = () => {
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (reducedMotion.matches || cards.length < 2 || document.hidden) return;
      autoplayTimer = window.setInterval(() => showCard(activeIndex + 1), 6500);
    };

    const restartAutoplayLater = () => {
      stopAutoplay();
      window.clearTimeout(restartTimer);
      restartTimer = window.setTimeout(startAutoplay, 9000);
    };

    previous.addEventListener('click', () => {
      showCard(activeIndex - 1);
      restartAutoplayLater();
    });

    next.addEventListener('click', () => {
      showCard(activeIndex + 1);
      restartAutoplayLater();
    });

    viewport.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = null;
        closestVisibleCard();
      });
    }, { passive: true });

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', (event) => {
      if (!carousel.contains(event.relatedTarget)) startAutoplay();
    });
    viewport.addEventListener('pointerdown', stopAutoplay, { passive: true });
    viewport.addEventListener('pointerup', restartAutoplayLater, { passive: true });
    viewport.addEventListener('pointercancel', restartAutoplayLater, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    reducedMotion.addEventListener?.('change', startAutoplay);
    setCounter();
    startAutoplay();
  });
})();
